import React from 'react';

import {greyishBlue100} from "assets/jss/main";

function SidebarBottomContainer(props) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                borderTop: `1px solid ${greyishBlue100}`,
                paddingTop: '12px',
                paddingBottom: '12px',
            }}
        >
            {props.children}
        </div>
    );
}

export default SidebarBottomContainer;
